import { makeImage } from "../utils";
import emojiSadDim from "./emoji-sad-dim.svg";

export const EmojiSadDim = makeImage({
  src: emojiSadDim,
  width: 64,
  height: 64,
  dataTestId: "emoji-sad-dim",
});
